import React from 'react';
import PropTypes from 'prop-types';
import 'components/styles/import-status.css';
import { SuccessFullyImported, ImportUnsuccessful, Importing } from './import-status';
import { ReactComponent as CloseIcon } from 'assets/images/black-close.svg';

const ImportStatus = ({
  selectedFile,
  closeDialog,
  setCloseDialog,
  importError,
  setImportError,
  handleInputButtonClick,
  showImportStatus,
  importStatus
}) => {

  return (
    <>
      {
        <div className={`importing-container ${showImportStatus && !closeDialog ? 'show' : ''}`}>
          <div className="importing-header">
            <div className="importing-head">Importing file</div>
            <div
              className="close-icon"
              onClick={() => {
                setCloseDialog(true);
                setImportError('');
              }}>
              <CloseIcon/>
            </div>
          </div>
          <div className="file-name">{selectedFile}</div>
          {importError ? (
            <ImportUnsuccessful
              error={importError}
              handleInputButtonClick={handleInputButtonClick}
            />
          ) : (
            <></>
          )}

          {importStatus === 'importing' ? <Importing /> : <></>}

          {importStatus === 'success' ? <SuccessFullyImported /> : <></>}

          {importStatus === 'unsuccesful' ? <ImportUnsuccessful handleInputButtonClick={handleInputButtonClick}/> : <></>}

        </div>
      }
    </>
  );
};

ImportStatus.propTypes = {
  selectedFile: PropTypes.string,
  setCloseDialog: PropTypes.func,
  closeDialog: PropTypes.bool,
  importError: PropTypes.string,
  setImportError: PropTypes.func,
  handleInputButtonClick: PropTypes.func,
  showImportStatus: PropTypes.bool,
  importStatus: PropTypes.string
};

export default ImportStatus;
